import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import { z } from 'zod'
import { CompareAudienceContextSchema, CompareAudienceRequestSchema, CompareAudienceResponseSchema } from './schemas.ts'

const c = initContract()
const BadRequestResponseSchema = z.union([ValidationErrorResponseSchema, ErrorResponseSchema])

export const audiencesContract = c.router(
  {
    compare: c.query({
      method: 'GET',
      path: '/flight-deck/v1/audiences/compare',
      description: 'Preview audiences by IDs to get live available audience sizes',
      query: CompareAudienceRequestSchema,
      request: CompareAudienceContextSchema,
      responses: {
        200: CompareAudienceResponseSchema,
        400: BadRequestResponseSchema,
        401: ErrorResponseSchema,
        404: ErrorResponseSchema,
        500: ErrorResponseSchema,
        502: ErrorResponseSchema,
        503: ErrorResponseSchema,
      },
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: BadRequestResponseSchema,
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Flight Deck'] },
  },
)

export type AudiencesContract = typeof audiencesContract
